import {PlayCircle} from 'lucide-react'
import { SlideIn, ViewportReveal, ScaleIn, Pulse } from "@/components/motion";

export function SuccessVideoSection() {
    return (
        <section id="how-it-works" className="bg-slate-50 px-4 pb-24 sm:px-6 lg:px-8">
            <ViewportReveal animation="fade" className="mx-auto max-w-5xl space-y-10 text-center">
                <SlideIn direction="up" delay={0.1}>
                    <p className="text-sm font-semibold uppercase tracking-[0.35em] text-[#324cc1]">How we help</p>
                </SlideIn>
                <SlideIn direction="up" delay={0.2}>
                    <h2 className="text-4xl font-extrabold text-slate-900 sm:text-5xl">How We Help You Succeed</h2>
                </SlideIn>
                <SlideIn direction="up" delay={0.3}>
                    <p className="text-lg text-slate-600">
                        Other platforms filter resumes and call it a day. We train, guide, and develop our experts
                        continuously. Watch the walkthrough to see the difference.
                    </p>
                </SlideIn>
            </ViewportReveal>

            <ScaleIn viewport delay={0.4} className="mx-auto mt-10 max-w-5xl rounded-[2rem] border-2 border-slate-200 bg-slate-900 p-4 shadow-2xl">
                <div className="relative aspect-video overflow-hidden rounded-[1.5rem] bg-black">
                    <iframe
                        src="https://player.vimeo.com/video/1146254707?h=b719c471c5"
                        title="AI Expert Network overview"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                        className="h-full w-full"
                        loading="lazy"
                    />
                </div>
                <div className="flex items-center gap-4 p-6 text-left">
                    <Pulse scale={1.08} duration={2.5}>
                        <div className="flex h-16 w-16 items-center justify-center rounded-full bg-[#2b42a3] text-white">
                            <PlayCircle className="h-8 w-8" />
                        </div>
                    </Pulse>
                    <div>
                        <p className="text-xl font-semibold text-white">Mark Kashef</p>
                        <p className="text-sm text-slate-300">Founder & CEO, AI Expert Network</p>
                    </div>
                </div>
            </ScaleIn>
        </section>
    )
}

